import {
  VStack,
  Box,
  HStack,
  Text,
  Badge,
  Icon,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import { FaArrowCircleUp } from "react-icons/fa";
import dateUtils from '../../utils/formatDate';
import { useTranslation } from "react-i18next";

const EarnedPointHistory = ({
  earnPointsTransactions,
  isLoading,
  bgColor,
  textColor,
  iconColor,
}) => {
  const savedLanguage = localStorage.getItem("i18nextLng") || "en";
  const {t} = useTranslation();

  return (
    <VStack
      width="100%"
      spacing={2}
      borderRadius="xl"
      overflowY="auto" // Enables vertical scrolling
      maxHeight="400px" // Adjust as needed to control the scrollable area
    >
      {isLoading ? (
        // Skeleton UI for Loading State
        Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            p={4}
            borderRadius="xl"
            bg={bgColor}
            color={textColor}
            borderBottomWidth={2}
            width="100%"
          >
            <HStack justify="space-between" align="center">
              <SkeletonCircle boxSize="6" />
              <Skeleton height="4" width="80px" />
              <Skeleton height="4" width="100px" />
              <Skeleton height="8" width="100px" />
            </HStack>
            <SkeletonText noOfLines={1} spacing="2" skeletonHeight="3" mt={2} />
          </Box>
        ))
      ) : Array.isArray(earnPointsTransactions) &&
        earnPointsTransactions.length > 0 ? (
        // Render Earned Points Transactions
        earnPointsTransactions
          .filter(
            (transaction) => transaction.type === "earn" && transaction.points !== 0 && !transaction.invoice_id.startsWith('INV')
          ) // Filter only 'earn' transactions
          .map((transaction) => (
            <Box
              key={transaction?.transaction_id}
              p={4}
              borderRadius="xl"
              bg={bgColor}
              color={textColor}
              borderBottomWidth={2}
              width="100%"
            >
              <HStack justify="space-between" align="center">
                <Icon
                  as={FaArrowCircleUp}
                  color={iconColor}
                  boxSize={6}
                  transform="rotate(220deg)"
                />

                <Text fontSize="xs" fontWeight="bold">
                  {dateUtils.formatDate(transaction?.createdAt, savedLanguage)}
                </Text>

                <VStack align="center" spacing={1}>
                  <Text fontSize="xs" color="gray.400">
                    {transaction?.added_by_name || "Unknown"}
                  </Text>
                </VStack>

                <HStack spacing={1} flex={2} justify="flex-end">
                  <Text color={iconColor} fontSize="xl" fontWeight="bold">
                    +{dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}
                  </Text>
                  <Badge color={iconColor} px={2} py={1} borderRadius="md">
                    {t('point')}
                  </Badge>
                </HStack>
              </HStack>

              {/* Expiration Date (Check if exists) */}
              {/* {transaction?.expiration_date && (
                <Text fontSize="xs" color="gray.500" mt={1}>
                  {t('expired_on',
                    { date: dateUtils.formatDate(transaction?.expiration_date, savedLanguage)}
                  )}
                </Text>
              )} */}
            </Box>
          ))
      ) : null }
    </VStack>
  );
};

export default EarnedPointHistory;
